<template>
    <v-dialog  persistent :value="show" @input="(!$event)? close() : null" :width="dialogWidth">
        <v-card >
            <v-card-title>
                {{title}}
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    dark
                    color="#575A5E"
                    @click="close()"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text v-if="options">
                <div v-html="description" v-if="description" class="my-5"></div>
                <v-btn class="ma-2" outlined v-for="option in options" @click="select(option.value)">
                    {{option.text}}
                </v-btn>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
    import Vue from 'vue';
    export default {
        data:() => {
            return{
                show:false,
                resolve: null,
                reject: null,
                title: null,
                description: null,
                options:null,
            }
        },
        mounted(){
            Vue.prototype.$selectDialog = this;
        },
        methods:{
            close(){
                this.show = false;
                this.reject();
            },
            select(item){
                this.resolve(item);
                this.show = false;
            },
            start(options, title = null, description = null){
                (!title)? this.title = this.$t('Select element') : this.title = title;
                (description)? this.description = description : null;
                return new Promise((resolve, reject) => {
                    this.resolve = resolve;
                    this.reject = reject;
                    this.show = true;
                    this.options = options;
                })
            }
        }
    }
</script>
